// @flow
/** @jsx h */
import { h } from 'preact';
import { route } from 'preact-router';
import { connect } from 'react-redux';
import TilesContainer from '../tilesContainer';
import {
  buyWithInstacredLandingRoute,
  buyWithInstacredLandingSearch,
} from '../../../alias/homeRoutes';
import type { MerchantType } from '../../../modelType/bicType';
import howToBuyAction from '../../../actions/howToBuyActions';
import howToBuyActionType from '../../../actions/howToBuyActions/actionType';
import { tracker, UserActionType } from '../../../tracking';
import MerchantCard from '../merchantCard';
import style from './style.css';
import CustomSlider from '../../common/customSlider';
import { useRef } from 'preact/hooks';
import { generateUrlWithParams } from '../../../utils/routeHandler';
import { isMobile } from '../../../utils/helper';

type Props = {
  campaignId: string,
  pageKey: string,
  header: string,
  merchants: Array<MerchantType>,
  lenderId: string,
};

const Merchants = ({
  merchants,
  pageKey,
  header,
  howToBuyAction,
  campaignId,
  lenderId,
}: Props) => {
  const customSliderRef = useRef(null);
  return (
    <TilesContainer
      title={"Shop at India's top merchants"}
      subTitle='2,00,000+ leading merchants accept cardless EMI'
      containerColor='#f7f7f7'
      additionalButton='See More'
      additionalButtonAction={() =>
        additionalButtonClick({ pageKey, campaignId, lenderId })
      }
      nextSlide={() => {
        customSliderRef.current.nextSlide();
      }}
      prevSlide={() => {
        customSliderRef.current.prevSlide();
      }}>
      <CustomSlider
        childWidth={isMobile ? 114 : 160}
        outerContainerClass={style.topStoreOuterContainer}
        ref={customSliderRef}
        noOfSlides={merchants.length}
        mobileViewWithSlider={true}
        customSettings={{
          dots: true,
          arrows: true,
          responsive: [
            {
              breakpoint: 769,
              settings: {
                rows: 2,
                dots: true,
                arrows: false,
              },
            },
          ],
        }}>
        {merchants.map((tile, index) => {
          return (
            <div className={style.merchantCardWrapper}>
              <MerchantCard
                customStyle={
                  isMobile
                    ? {
                        width: '104px',
                        height: '52px',
                      }
                    : {
                        width: '136px',
                        height: '68px',
                      }
                }
                campaignId={campaignId}
                tile={tile}
                index={index}
                pageKey={pageKey}
                header={header}
                lenderId={lenderId}
                howToBuyClick={() => {
                  howToBuyAction(howToBuyActionType.redirectToHTB, {
                    referralUrl: generateUrlWithParams(
                      buyWithInstacredLandingRoute.path,
                    ),
                  });
                }}
              />
            </div>
          );
        })}
      </CustomSlider>
    </TilesContainer>
  );
};

const additionalButtonClick = ({ pageKey, campaignId, lenderId }) => {
  tracker.trackUserInteraction(
    UserActionType.CLICK,
    'bic_top_merchants_see_more',
    pageKey,
    {
      campaign_id: campaignId,
      lender_id: lenderId,
    },
  );
  return route(
    `${buyWithInstacredLandingSearch.path}${window.location.search}${
      window.location.search ? '&' : '?'
    }topmerchants=true`,
  );
};

const mapStateToProps = ({ buyWithInstacred, config }) => {
  const { home } = buyWithInstacred || {};
  const { campaignId, merchants } = home || {};
  const { lenderDetails } = config;
  const { lenderId } = lenderDetails || {};
  return {
    merchants,
    campaignId,
    lenderId,
  };
};
export default connect(
  mapStateToProps,
  { howToBuyAction },
)(Merchants);



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/merchants/index.js